<template>
  <div>
    <HeraFormDropdown
      v-model="bestOf"
      v-validate="'required'"
      name="bestOf"
      :label="bestOfLabel"
      :list="bestOfList"
      :class="{ 'is-invalid': errors.first('bestOf') }"
      variant="input-like"
      :view-mode="disabled"
      :disabled="isStageFieldDisabled('bestOf') || disabled"
      required
      :error="errors.first('bestOf')"
      :empty-text="$$t('Choose option', 'best-of-placeholder')"
      :tooltip="
        $$t(
          'How many games within one match must be played between opponents (except a final match)',
          'best-of-tooltip'
        )
      "
      show-label
      empty-option
    >
      <template slot="chosen" slot-scope="chosen">
        {{ chosen.chosenItem }}
      </template>

      <template slot="item" slot-scope="{ item }">
        {{ item }}
      </template>
    </HeraFormDropdown>
  </div>
</template>

<script>
import { translate } from '@/mixins/translate';

import HeraFormDropdown from '@/components/molecules/form/HeraFormDropdown';
import stageSetupHelpers from '@/views/tournaments/management/singleTournament/mixins/stageHelpers';
import { prop } from '@/utils/factories';
export default {
  name: 'StageBestOfSetting',
  components: {
    HeraFormDropdown,
  },
  inject: ['$validator'],
  mixins: [translate('_web_tournament_stage-editor'), stageSetupHelpers],
  props: {
    disabled: prop(Boolean),
  },
  computed: {
    bestOf: {
      get() {
        return this.getBlockConfigurationByKey('best_of');
      },
      set(newVal) {
        if (+newVal === 1) {
          this.setBlockConfigurationByKey('tie_game', this.tieMatchAllowed);
        }
        this.setBlockConfigurationByKey('best_of', +newVal);
      },
    },
    bestOfLabel() {
      return this.isDoubleElimination
        ? this.$$t('Best of (Upper):', 'best-of-upper_label')
        : this.$$t('Best of:', 'best-of_label');
    },
    bestOfList() {
      return this.stageDefaults[this.tieMatchAllowed ? 'bestOfTie' : 'bestOf'];
    },
  },
};
</script>

<style></style>
